/* This is ment to build provide a quick starting point when starting new index type file */
import React from 'react';
import videoContentStyle from './style';
import videoContent from '../../config/videos';
import VideoFrame from './videoFrame';

export default function VideoContent() {
	let style = videoContentStyle();
	return (
		<div style={style.outerStyle()}>
			<h1 className='mt-5 nice-header text-center px-3 text-black'>Video Content</h1>
			<p className='mt-5 px-3'>Further contextual reference to each video can be found in the course page</p>

			{videoContent.map((videoCategory, i) => {
				return (
					<>
						<h1 style={style.subHeader()} className='mt-5 nice-header text-center px-3 text-black'>
							{videoCategory.category}
						</h1>
						{videoCategory.videos.map((video, j) => {
							return (
								<>
									<p className='mt-5 px-3'>{video.title}</p>
									<VideoFrame id={video.id} thumbnail={video.thumbnail} i={j} />
								</>
							);
						})}
					</>
				);
			})}
		</div>
	);
}
